import { eAssetType } from "../../@types/Asset";
import { RankingPaginator } from "../../@types/Ranking";
import { api } from "../api";

export default async function getPaginator(
  assetType: eAssetType,
  actualPage: number,
  perPage: number,
  orderBy: string,
  onlyBr: boolean
): Promise<RankingPaginator | null> {
  try {
    const { data } = await api.get(
      `/ranking/?assetType=${assetType}&page=${actualPage}&perPage=${perPage}&orderBy=${orderBy}&onlyBR=${onlyBr}`
    );

    return data;
  } catch (err) {
    console.error(err);

    return null;
  }
}
